import { Text } from "@ui-kitten/components";
import BottomSheet from "components/BottomSheet/BottomSheet";
import React from "react";
import { View } from "react-native";

interface ReleaseNotesSheetProps {
  visible: boolean;
  onClose: () => void;
}

const ReleaseNotesSheet = ({
  visible,
  onClose,
}: ReleaseNotesSheetProps): React.JSX.Element => {
  return (
    <BottomSheet
      visible={visible}
      onClose={onClose}
      title="Recent Release Notes"
    >
      <View style={{ padding: 20 }}>
        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          06/2026
        </Text>
        <Text style={{ marginBottom: 16 }}>• Bug fixes</Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          05/2026
        </Text>
        <Text style={{ marginBottom: 16 }}>
          • Family plan limit: cap on how many plans per family group a member
          can sign up for
        </Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          04/2026
        </Text>
        <Text style={{ marginBottom: 2 }}>
          • Select individual tickets when initiating a transfer
        </Text>
        <Text style={{ marginBottom: 2 }}>
          • Add-on tickets to existing reservations without releasing original
          seats
        </Text>
        <Text style={{ marginBottom: 16 }}>
          • Seat upgrade flow highlights your current seats and smart
          pre-selects adjacent available seats
        </Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          03/2026
        </Text>
        <Text style={{ marginBottom: 16 }}>
          • Deferred seat assignment flow for booking requests requiring
          qualification review
        </Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          02/2026
        </Text>
        <Text style={{ marginBottom: 2 }}>
          • Season ticket purchase integrated into the shop (seat map, cart, and
          checkout)
        </Text>
        <Text style={{ marginBottom: 16 }}>
          • Marketing consent preferences (email & SMS) added to buy and reserve
          flows
        </Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          01/2026
        </Text>
        <Text style={{ marginBottom: 16 }}>
          • Season ticket purchase flow: browse sections, select seats on a seat
          map, and purchase in-app
        </Text>

        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          11/24/2025
        </Text>
        <Text style={{ marginBottom: 16 }}>UX improvements</Text>
        <Text category="s1" style={{ fontWeight: "700", marginBottom: 4 }}>
          11/20/2025
        </Text>
        <Text>Bug fixes</Text>
      </View>
    </BottomSheet>
  );
};

export default ReleaseNotesSheet;
